module.exports = __webpack_public_path__ + "static/media/logo173.6b1526ca.png";